import React from 'react';

const icon3 = () => {
    return (
        <>
        <svg
                    width="40"
                    height="41"
                    viewBox="0 0 40 41"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.22069 27.067L27.6157 6.67032C28.4214 5.89926 29.4971 5.47433 30.6122 5.48652C31.7274 5.49871 32.7935 5.94705 33.5822 6.73553C34.3709 7.52401 34.8195 8.58996 34.832 9.70513C34.8445 10.8203 34.4199 11.896 33.649 12.702L13.2507 33.0987C12.7854 33.564 12.1927 33.8812 11.5474 34.0103L4.99902 35.3203L6.30902 28.7703C6.4381 28.125 6.75532 27.5323 7.22069 27.067Z"
                      stroke="white"
                      strokeWidth="3.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M24.166 11.1536L29.166 16.1536"
                      stroke="white"
                      strokeWidth="3.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
            
        </>
    );
};

export default icon3;